import getListViewState from "../selectors/getListViewState";
import isMessageListBranchExpansionType from "owa-mail-organization-settings/lib/utils/isMessageListBranchExpansionType";
import getRowExpansionState, { ExpansionState } from "./getRowExpansionState";

export function isFirstLevelExpanded(rowKey: string): boolean {
    return (isMessageListBranchExpansionType() &&
        getRowExpansionState(rowKey) === ExpansionState.BRANCHED);
}

export function isSecondLevelExpanded(rowKey: string): boolean {
    if (isMessageListBranchExpansionType()) {
        return getRowExpansionState(rowKey) === ExpansionState.FULLY_EXPANDED;
    }
    const listViewState = getListViewState();
    return (listViewState.expandedConversationViewState.expandedRowKey == rowKey &&
        !listViewState.expandedConversationViewState.shouldBeExpanded);
}

export function isLoadingSecondLevelExpansion(rowKey: string): boolean {
    return (isMessageListBranchExpansionType() &&
        getRowExpansionState(rowKey) === ExpansionState.LOADING_ITEM_PARTS);
}
